interface SkeletonCardProps {
  readonly variant?: 'square' | 'wide'
}

export function SkeletonCard({ variant = 'square' }: SkeletonCardProps) {
  return (
    <div className="flex flex-col overflow-hidden rounded-xl border border-tg-hint/10 bg-tg-secondary shadow-sm">
      {/* Image placeholder */}
      <div className={`aspect-square w-full shimmer ${variant === 'wide' ? 'h-32' : ''}`} />
      {/* Text placeholders */}
      <div className="flex flex-col gap-2 p-2">
        <div className="h-3 w-full rounded shimmer" />
        <div className="h-2 w-3/4 rounded shimmer" />
      </div>
    </div>
  )
}
